import React from 'react';
import { Col, Row, Button, Table, Modal, DatePicker } from 'antd';
import { DownloadOutlined, ArrowRightOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { CommissionSummaryExcelDownload } from '@sharedComponent/excel/excel';
import Header from '@sharedComponent/header/header';
import LottieComponent from '@sharedComponent/lottie-component';
import LottieFile from '@assets/lottiefiles';
import { disableFutureDate, daysBetweenTwoDates } from '@helpers';
import { dateFormats } from '@constants';
import GifLoader from '@sharedComponent/gif-loader';

const dateFormat = 'MM/DD/YYYY';
const { RangePicker } = DatePicker;
const CommissionSummaryPresentational = ({
	userDetails,
	state,
	handleModal,
	commissionSummaryData,
	commissionSummaryLoading,
	dataRangeChanged,
	createSummary,
}) => {
	const { modalOpened } = state;
	const columns = [
		{
			title: 'Affiliate Name',
			dataIndex: 'affiliateName',
			key: 'click',
			sorter: (a, b) => a.name.localeCompare(b.name),
			render: (value, row, index) => {
				return (
					<Row align="middle">
						<Col className="flc">
							<Col className={`${value[0].toUpperCase()}_text text_box flc`}>
								<Link
									to="/view-affiliate"
									style={{
										color: '#fff',
									}}>
									{value[0]}
								</Link>
							</Col>
						</Col>
						<Col>{value}</Col>
					</Row>
				);
			},
		},
		{
			title: 'Report Date',
			dataIndex: 'reportDate',
			sorter: (a, b) => a.name.localeCompare(b.name),
			key: 'reportDate',
			// render: (value) => moment(value, dateFormats.MM_DD_YYYY),
		},
		{
			title: 'Commision Amount',
			dataIndex: 'commissionAmount',
			sorter: (a, b) => a.name.localeCompare(b.name),
			key: 'commissionAmount',
		},
		{
			title: 'Commission Status',
			dataIndex: 'status',
			key: 'status',
			sorter: (a, b) => a.name.localeCompare(b.name),
			render: (value, row, index) => {
				return (
					<Row align="middle">
						<Col className="flc">
							<Col className={`${row.status} status_circle`} />
						</Col>
						<Col>{value}</Col>
					</Row>
				);
			},
		},

		{
			title: '',
			dataIndex: 'title',
			key: 'title',
			render: (a, row) => {
				return (
					<Col>
						<Link to={`/commission-summary/view-summary/${row.affiliateId}`}>
							View Summary <ArrowRightOutlined style={{ marginLeft: 5 }} />
						</Link>
					</Col>
				);
			},
		},
	];

	const dataSource = [
		{
			date: '10/02/2020',
			status: 'Pending',
			Amount: '$ 200',
			name: 'Micheal',
		},
	];

	const numberOfDays = daysBetweenTwoDates(state.fromDate, state.toDate);
	return (
		<>
			{state.loading ? (
				<Col style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center' }}>
					{/* <LottieComponent width="10%" height="10%" file={LottieFile.Loading} /> */}
					<GifLoader />
				</Col>
			) : (
				<>
					<Modal
						title="Pick date"
						visible={modalOpened}
						closable={false}
						footer={[
							<Button onClick={() => handleModal(false)} key="back" type="ghost">
								Close
							</Button>,
							<Button loading={commissionSummaryLoading} onClick={createSummary} style={{ height: '100%' }} key="submit" type="primary">
								Submit
							</Button>,
						]}>
						<RangePicker
							autoFocus={modalOpened}
							style={{ width: '100%' }}
							disabledDate={disableFutureDate}
							// open={modalOpened}
							defaultValue={[moment(state.fromDate, dateFormats.MM_DD_YYYY), moment(state.toDate, dateFormats.MM_DD_YYYY)]}
							format={dateFormats.MM_DD_YYYY}
							onCalendarChange={(e, value) => {
								dataRangeChanged(value);
							}}
						/>
					</Modal>
					<Header title="Dashboard / Commission Management" />
					<Col className="commission-summary-container">
						<Row>
							<Col xl={12} lg={12} md={12} sm={24} xs={24} className="commission-summary-card-header">
								Commission Management
							</Col>
							<Col xl={12} lg={12} md={12} sm={24} xs={24} className="commission-summary-card-header-right">
								<Button loading={commissionSummaryLoading} onClick={() => handleModal(true)} className="create-sum-btn">
									CREATE SUMMARY
								</Button>
								<Button
									type="primary"
									className="excel_download"
									icon={<DownloadOutlined />}
									style={{ borderRadius: 5 }}
									size={'middle'}>
									Export to EXCEL
									<CommissionSummaryExcelDownload
										style={{ visibility: 'hidden' }}
										dataSet={commissionSummaryData}
										userDetails={userDetails}
										filename={`${moment(new Date()).format(
											dateFormat
										)}_Commission_summary_Report`}></CommissionSummaryExcelDownload>
								</Button>
							</Col>
						</Row>
						<Col style={{ marginTop: 10 }}>
							{commissionSummaryLoading ? (
								<Col style={{ display: 'flex', height: '300px', justifyContent: 'center', alignItems: 'center' }}>
									{/* <LottieComponent width="30%" height="30%" file={LottieFile.Loading} /> */}
									<GifLoader />
								</Col>
							) : (
								<Table
									className="commission_summary_table"
									pagination={{
										position: ['bottomCenter', 'bottomCenter'],
										defaultPageSize: 5,
										showSizeChanger: true,
										pageSizeOptions: ['5', '10'],
									}}
									dataSource={commissionSummaryData}
									columns={columns}
								/>
							)}
						</Col>
					</Col>
				</>
			)}
		</>
	);
};

export default CommissionSummaryPresentational;
